export const login = () => {
  loginH5();
};

export const loginH5 = () => {
  if (process.env.VUE_APP_ENABLE_TEST_LOGIN === 'true') {
    window.location.href = `${window.location.origin}/#/test_login`;
    return;
  }
  let redirectUri = `?redirect_uri=${encodeURIComponent(`${window.location.origin}/#/wx_blank?redirect_url=${encodeURIComponent(window.location.hash.substring(1))}`)}`;
  window.location.href = `${process.env.VUE_APP_DOMAIN}/Weixin/auth2.html${redirectUri}`;
};
